import styled from 'styled-components';

export const StyledContent = styled.div` 
margin: 0;
width: 100vw;
height: 100vh;
background-color: hsl(180, 52%, 96%);
display: flex;
flex-direction: column;
text-align: center;

`
export const StyledHeader = styled.div`  
  width: 100vw;
  height: 150px;
  background-image: url('../img/bg-header-desktop.svg');
  background-repeat: no-repeat;
  background-size: contain;
`
export const ImgHeader = styled.img`
width: 100vw;
height: 150px;
`